class PublicSeatsController {
    constructor($state, $stateParams, NavService, $http, $filter, $q, $scope, SweetAlert) {
        this.state = $state;
        this.stateParams = $stateParams;
        this.navService = NavService;
        this.guestlistId = this.stateParams.gid;
        this.api = $http;
        this.filter = $filter;
        this.scope = $scope;
        this.sweetAlert = SweetAlert;

        this.loading = true;
        this.guestlist = null;
        this.seatplan = null;

        this.publicBookableElements = {};
        this.blockedElements = [];
        this.currentSelectedElements = [];
        this.bookingInformation = {};

        this.currentGroup = false;

        $q.all([
            this._loadGuestlist(),
            this._updateAlreadyDefinedPublicElements()
        ]).then(() => {
            this.activateGroup(this.seatplan.groups.data[0]);
            this._updateCustomActions();
            this.loading = false;
        });

        this._updateToolbox();
    }

    // Public functions
    activateGroup(group) {
        this.currentGroup = group.id;
        this._updateCustomActions();
        if(this.publicBookableElements[group.id]) {
            this.currentSelectedElements = this.publicBookableElements[group.id];
        } else {
            this.currentSelectedElements = [];
        }
        // this._updateToolbox();
        // this._resetSelected();
    }

    save() {
        this.loading = true;

        return this.api.put('guestlists/' + this.guestlistId + '/seatplan/public-elements', this._prepareDataForSaving()).then((response) => {
            this.publicBookableElements = response.data;
            // this.activateGroup(this.currentGroup);
            this.loading = false;
            this.sweetAlert.success('Success', 'Public seats have been saved.');
        }, () => {
            this.sweetAlert.error('Error', 'Error while saving public seats.')
        });
    }

    handleSeatplanSelectionChange(triggeredElement, selectionState, allSelectedElements) {
        this.scope.$applyAsync(() => {
            this.publicBookableElements[this.currentGroup] = [];
            _.each(allSelectedElements, (element) => {
                this.publicBookableElements[this.currentGroup].push(element.id);
            });

            this.currentSelectedElements = this.publicBookableElements[this.currentGroup];
        });
    }

    // Internal functions
    _loadGuestlist() {
        return this.api.get('guestlists/' + this.guestlistId + '?include=blockedSeatplanElements,seatplan,seatplan.groups').then((response) => {
            const responseData = response.data.data;
            this.guestlist = _.cloneDeep(responseData);
            delete this.guestlist.seatplan;
            delete this.guestlist.blockedSeatplanElements;

            this.navService.setBreadcrumbParameters({
                date: this.filter('date')(this.guestlist.date, 'd.M.yyyy'),
                shift: this.guestlist.shift.label
            });

            this.blockedElements = [];
            _.forEach(responseData.blockedSeatplanElements.data, (val) => {
                this.blockedElements.push(val.id);
            });

            this.seatplan = _.cloneDeep(responseData.seatplan.data);
        });
    }

    _updateAlreadyDefinedPublicElements() {
        return this.api.get('guestlists/' + this.guestlistId + '/seatplan/public-elements').then((response) => {
            this.publicBookableElements = response.data;
        });
    }

    _prepareDataForSaving(){
        const out = {
            'bookable-elements': []
        };

        _.each(this.publicBookableElements, (elementIds) => {
            if(_.isArray(elementIds) && elementIds.length > 0) {
                out['bookable-elements'] = out['bookable-elements'].concat(elementIds);
            }
        });

        return out;
    }

    _updateToolbox() {
        const actions = [];
        actions.push({
            label: 'Back to bookings',
            action: () => {
                this._goToSeatsView();
            },
            icon: 'arrow-left',
            order: 10
        });

        this.navService.overrideMainSideNavActions(actions);
    }

    _updateCustomActions() {
        this.navService.shouldShowBackBtn(false);
        const customs = [];
        _.each(this.seatplan.groups.data, (group) => {
            customs.push({
                label: group.title,
                key: 'group-' + group.id,
                icon: 'char-' + group.title[0].toLowerCase(),
                order: group.title[0].toLowerCase(),
                action: () => {
                    this.activateGroup(group);
                },
                active: group.id === this.currentGroup
            });
        });

        this.navService.setSideNavCustoms(customs);
    }

    _goToSeatsView() {
        this.state.go('app.guestlists.rsvps.seats', {gid: this.guestlistId});
    }

}

PublicSeatsController.$inject = [
    '$state',
    '$stateParams',
    'NavService',
    '$http',
    '$filter',
    '$q',
    '$scope',
    'SweetAlert'
];

/**
 * @ngdoc object
 * @name guestlists.controller:PublicSeatsController
 *
 * @description
 *
 */
angular
    .module('festzelt-os.guestlists')
    .controller('PublicSeatsController', PublicSeatsController);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/guestlists/seats/public-seats-controller.js